import { takeLatest } from "redux-saga/effects"

import { apiGeneratorBase } from "../../../Utils/saga"
import Creators, { RequestsGiftsTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getRequestsGiftsActions: {
    request: Creators.getRequestsGiftsRequest,
    success: Creators.getRequestsGiftsSuccess,
    errors: Creators.requestsGiftsFailure
  }
}

const eventsOptions = {
  [constants.GET_REQUESTS_GIFTS_REQUEST]: {
    api: services.getRequestsGifts,
    actions: actions.getRequestsGiftsActions
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_REQUESTS_GIFTS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_REQUESTS_GIFTS_REQUEST])
  )
}
